import script from "./RedeemGiftResultView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RedeemGiftResultView.vue?vue&type=script&lang=ts&setup=true"

import "./RedeemGiftResultView.vue?vue&type=style&index=0&id=d01eccf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d01eccf0"]])

export default __exports__